module.exports = __webpack_public_path__ + "static/ITCAvantGardeStd-Bold-30b488906796e9140234fb1febbea960.woff";